import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
import { IContactInfoFormValues } from '../../../../@types/model/masterData/contactInfo/contactInfoFormValues';
import { PillButton, ControlledTextField } from '@zz2/zz2-ui';
import { ControlledLabelledCheckBox } from '../../../../components/input/form/ControlledLabelledCheckBoxWrapper';
import { yupResolver } from '@hookform/resolvers/yup';
import ContactInfoModelHelper from '../../../../@types/model/masterData/contactInfo/contactInfoModelHelper';
import CustomReactHookFormDevTools from '../../../../components/devtools/ReactHookFormDevTools';

interface IContactInfoFormProps {
    isLoading : boolean;
    initialValues : IContactInfoFormValues;
    onSubmit : (values : IContactInfoFormValues) => void;
    onClose : () => void;
}

const ContactInfoForm = (props : IContactInfoFormProps) : React.ReactElement => {
    const { handleSubmit, control, formState: { isValid, isDirty }, trigger } = useForm<IContactInfoFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(ContactInfoModelHelper.formSchema()),
        mode: 'onChange',
    });

    /*================================================================================================================
     *                                                  Effects
     * ==============================================================================================================*/

    useEffect(() => {
        trigger();
    }, []);

    /*================================================================================================================
     *                                                  Async Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Handler Methods
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Memos
     * ==============================================================================================================*/

    /*================================================================================================================
     *                                                  Render Methods
     * ==============================================================================================================*/

    return (
        <div>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className={'fdc p20'}>
                    <ControlledTextField
                        className={'mb10'}
                        name={'name'}
                        label={'Name'}
                        control={control}
                        defaultValue={props.initialValues.name}
                        size={'small'}
                    />
                    <ControlledTextField
                        className={'mb10'}
                        name={'address'}
                        label={'Address'}
                        control={control}
                        defaultValue={props.initialValues.address}
                        multiline
                        rows={5}
                        size={'small'}
                    />
                    <ControlledTextField
                        className={'mb10'}
                        name={'telNumber'}
                        label={'Telephone Number'}
                        control={control}
                        defaultValue={props.initialValues.telNumber}
                        size={'small'}
                    />
                    <ControlledTextField
                        className={'mb10'}
                        name={'faxNumber'}
                        label={'Fax Number'}
                        control={control}
                        defaultValue={props.initialValues.faxNumber}
                        size={'small'}
                    />
                    <ControlledTextField
                        className={'mb10'}
                        name={'email'}
                        label={'Email'}
                        control={control}
                        defaultValue={props.initialValues.email}
                        size={'small'}
                    />
                    <div className={'flx1 fdr jcfs'}>
                        <ControlledLabelledCheckBox
                            label={'Active?'}
                            name={'isActive'}
                            control={control}
                            defaultValue={props.initialValues.isActive}
                            disabled={props.initialValues.isActive}
                        />
                    </div>
                    <div className={'fdr flx1 aic jcfe'}>
                        <Button className={'cpd mr20'} type={'button'} onClick={props.onClose}>
                            CANCEL
                        </Button>
                        <PillButton
                            className={'pl30 pr30'}
                            text={'SAVE'}
                            size={'small'}
                            type={'submit'}
                            color={'secondary'}
                            disabled={ !isDirty || !isValid || props.isLoading }
                        />
                    </div>
                </div>
            </form>
            <CustomReactHookFormDevTools control={control} />
        </div>
    );
};

export default ContactInfoForm;
